angular.module('bmsApp.employee').factory('EmployeeSvc', function (CRUDSvc, EMPLOYEE_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(EMPLOYEE_API.INDEX, params);
		},
		create: function (employee) {
			return CRUDSvc.post(EMPLOYEE_API.CREATE, employee);
		},
		read: function (id) {
			return CRUDSvc.get(EMPLOYEE_API.READ + id);
		},
		update: function (id, employee) {
			return CRUDSvc.post(EMPLOYEE_API.UPDATE + id, employee);
		},
		import: function (employees) {
			return CRUDSvc.post(EMPLOYEE_API.IMPORT, employees);
		},
		updateBulk: function (selectedEmployees) {
			return CRUDSvc.post(EMPLOYEE_API.UPDATE_BULK, selectedEmployees);
		},
		safe: function (params) {
			return CRUDSvc.post(EMPLOYEE_API.SAFE, params);
		},
		statistics: function () {
			return CRUDSvc.get(EMPLOYEE_API.STATISTICS);
		},
		carCalendarEvents: function (params) {
			return CRUDSvc.get(EMPLOYEE_API.CAR_CALENDAR_EVENTS, params);
		},
        getAvailable: function (params) {
            return CRUDSvc.get(EMPLOYEE_API.GET_AVAILABLE, params);
        },
		getTGEmployeeVisitDuration: function(visits) {
			var employeeMinutes = 0;
			angular.forEach(visits, function(visit) {
				if (!visit.inactive) {
					employeeMinutes += parseFloat(visit.work_duration_in_mins);
				}
			});

			return employeeMinutes;
		},
		export: function(params) {
			var newParams = angular.extend({}, params, {
				'format': 'csv'
			});
			console.log(newParams);
			var query = $.param(newParams);
			console.log(query);

			window.open(EMPLOYEE_API.INDEX + '?' + query);
		},
	};

}).constant('EMPLOYEE_API', {
	INDEX: 'api/employee',
	CREATE: 'api/employee/create',
	READ: 'api/employee/read/',
	UPDATE: 'api/employee/update/',
	IMPORT: 'api/employee/import',
	SAFE: 'api/employee/safe',
	UPDATE_BULK: 'api/employee/updateBulk',
	STATISTICS: 'api/employee/statistics',
	CAR_CALENDAR_EVENTS: 'api/employee/car/calendarEvents',
	GET_AVAILABLE: 'api/employee/getAvailable'
});
